<template>
  <div></div>
</template>

<script>
export default {
  name: "not-found",
  beforeMount() {
    this.$router.push({ name: "shopping-cart", params: { locale: this.$i18n.locale } });
  },
};
</script>